import { Col, Container, Row, Card, CardBody, Badge } from "reactstrap";
import pkgJSON from "./../../../package.json";
import { useTranslation } from "react-i18next";

function About() {
  const applicationVersion = pkgJSON.version;
  const apiVersion = "v1.1.1";
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={6}>
            <Card className="shadow-sm border-0">
              <CardBody className="p-4">
                <h1 className="text-center mb-4">{t("About the Application")}</h1>
                <Row className="text-center">
                  <Col xs={12} md={6} className="mb-3">
                    <div className="border rounded p-3">
                      <h5 className="mb-2">
                        <span className="py-3">{t("UI Version")}</span>
                        <Badge color="primary" className="ms-2 py-2">UI</Badge>
                      </h5>
                      <h3 className="mb-0">v{applicationVersion}</h3>
                    </div>
                  </Col>

                  <Col xs={12} md={6}>
                    <div className="border rounded p-3">
                      <h5 className="mb-2">
                        <span className="py-3">{t("API Version")}</span>
                        <Badge color="success" className="ms-2 py-2">API</Badge>
                      </h5>
                      <h3 className="mb-0">
                        {apiVersion}
                      </h3>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About; 